import { Box, Divider, Grid, Paper, Tooltip,ListItem, Typography } from "@mui/material";
import React from "react";
import { FC, useEffect, useState } from "react";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { UserGroups as Groups, UserGroupDescription, UserGroupLabel } from "../../../enums/user-groups";
import { UserInfo } from "../../../reducers/states/user-info";

interface UserProps {
    userSelection: UserInfo;
    userGroups: string[];
}

const UserGroups: FC<UserProps> = (props) => {
  const [userGroups, setUserGroups] = useState([] as string[]);

  useEffect(() => {
    setUserGroups(props.userGroups);
  }, [props.userGroups]);

  function getDescription(role: string) {
    switch (role) {
      case Groups.AGENCY_ADMIN:
        return UserGroupLabel.AGENCY_ADMIN;
      case Groups.INC_CONTRIBUTOR:
        return UserGroupLabel.INC_CONTRIBUTOR;
      case Groups.INC_MANAGER:
        return UserGroupLabel.INC_MANAGER;
      case Groups.INC_RECORDS_MANAGER:
        return UserGroupLabel.INC_RECORDS_MANAGER;
      case Groups.MAJOR_EVENT_CONTRIBUTOR:
        return UserGroupLabel.MAJOR_EVENT_CONTRIBUTOR;
      case Groups.PIO:
        return UserGroupLabel.PIO;
      case Groups.SITE_ADMIN:
        return UserGroupLabel.SITE_ADMIN;
      case Groups.VCC_BASIC:
        return UserGroupLabel.VCC_BASIC;
      default:
        return role;
    }
  }

  function getToolTip(role: string) {
    switch (role) {
      case Groups.AGENCY_ADMIN:
        return UserGroupDescription.AGENCY_ADMIN;
      case Groups.INC_CONTRIBUTOR:
        return UserGroupDescription.INC_CONTRIBUTOR;
      case Groups.INC_MANAGER:
        return UserGroupDescription.INC_MANAGER;
      case Groups.INC_RECORDS_MANAGER:
        return UserGroupDescription.INC_RECORDS_MANAGER;
      case Groups.MAJOR_EVENT_CONTRIBUTOR:
        return UserGroupDescription.MAJOR_EVENT_CONTRIBUTOR;
      case Groups.PIO:
        return UserGroupDescription.PIO;
      case Groups.SITE_ADMIN:
        return UserGroupDescription.SITE_ADMIN;
      case Groups.VCC_BASIC:
        return UserGroupDescription.VCC_BASIC;
      default:
        return "";
    }
  }

  return (
    <>
      <Box mt={1}>
        <Paper variant="outlined">
          <Grid container direction="row" alignItems="center">
            <Grid item xs={12}>
              <Box mt={1} ml={1} mb={0.5}>
                <Typography variant={"subtitle1"}>Roles and Permissions</Typography>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box m={1}>
                <Divider />
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box m={0} display="flex" flexDirection="column">
                {userGroups &&
                  userGroups.map((group: string, index) => (
                    <Box key={group}>
                      <ListItem>
                        <Grid item xs={11}>
                          <Typography key={group} variant="subtitle2" style={{ alignItems: "left", padding: 1 }}>
                            {getDescription(group)}
                          </Typography>
                        </Grid>

                        <Grid item xs={1}>
                          {getToolTip(group) ? (
                            <Tooltip title={getToolTip(group)}>
                              <InfoOutlinedIcon style={{ alignItems: "right" }} color="action" />
                            </Tooltip>
                          ) : (
                            <></>
                          )}
                        </Grid>
                      </ListItem>
                    </Box>
                  ))}
              </Box>
            </Grid>
          </Grid>
        </Paper>
      </Box>
    </>
  );
};
  
  export default UserGroups;
  